import React from 'react';
import Slider from 'react-slick';
import Link from 'next/link';
import { useChallengeAdList } from '@repository/match';
import { MatchingChallengeAdVO } from '@domain/vo/challenge/MatchingChallengeAdListVO';

import classnames from 'classnames/bind';
import styles from './challengeBanner.module.scss';
const cx = classnames.bind(styles);

const bannerSettings = {
  // 배너(광고) Slider settings
  dots: true,
  infinite: true,
  speed: 1000, // milliseconds
  autoplay: true, // 자동 재생 여부
  autoplaySpeed: 6000,
  swipe: true,
  arrows: false,
};

const challengeBannerCard = (banner: MatchingChallengeAdVO) => {
  return (
    <Link key={banner.sn} href={banner.bannerLink} legacyBehavior>
      <a
        target="_blank"
        className={cx('link')}
        style={{ backgroundImage: `url('${banner.pcBannerImage}')` }}
        draggable={false}
      />
    </Link>
  );
};

const ChallengeBanner = () => {
  const { data, isLoading } = useChallengeAdList();

  if (!data || isLoading) return null;

  const banner = data.challengeAds.map((challengeAd) => challengeBannerCard(challengeAd));

  return (
    <Slider className={cx('bannerArea')} {...bannerSettings}>
      {banner}
    </Slider>
  );
};

export default ChallengeBanner;
